import PreviewImage from '../../components/PreviewImage';
import './style.scss';

const PhotoResult = (props) => {
  return (
    <div>
      <PreviewImage />
    </div>
  );
};

export default PhotoResult;
